import { createFileRoute } from '@tanstack/react-router'

import { WalletSection } from '@/modules/account'
import { useIsScreenerEntitled } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute('/_authenticated/credits/')({
  component: BuyCreditsPage,
})

function BuyCreditsPage() {
  const isScreenerEntitled = useIsScreenerEntitled()

  return (
    <>
      <WalletSection wallet="pages" />
      {isScreenerEntitled && (
        <WalletSection wallet="screenings" className="border-t pt-8" />
      )}
    </>
  )
}
